<p-confirmDialog header="{{'General.info' | translate}}" icon="pi pi-exclamation-triangle"
    acceptLabel="{{'General.accept' | translate}}" rejectLabel="{{'General.cancel' | translate}}"
    key="procurementProjectConfirmDialog"></p-confirmDialog>
<!-- <waitLoading *ngIf="!isLoaded()"></waitLoading> -->
<div [ngClass]="{ 'wrapper wrapper-content': !task }">
    <div class="container-fluid  ng-scope" style="padding-bottom: 25px;">
        <!-- SELECCION DE PANTALLA -->
        <div class="row" *ngIf="selectStepMode && isLoaded()">
            <div class="col-12">
                <div
                    class="row justify-content-sm-center justify-content-lg-start text-lg-left offset-top-50 offset-xl-top-66">
                    <!--div class="col-12"><span class="alert alert-info" ><i class="fas fa-info"></i> Seleccionar el expediente o modelo a iniciar.</span></div-->
                    <div class="col-md-9 col-lg-4 offset-xl-0 m-b-lg"
                        *ngFor="let stepDef of stepsDefinition.definitions">
                        <!-- Icon Box Type 3-->
                        <div
                            class="unit align-items-center unit-spacing-xs unit-xs flex-sm-row text-center text-sm-left">
                            <div class="unit-left">
                                <span
                                    class="icon novi-icon text-middle icon-sm text-primary mdi mdi-account-check"></span>
                            </div>
                            <div class="unit-body">
                                <h5 class="ui-card-title border-bottom border-dark"> {{ stepDef.name }} </h5>
                            </div>
                        </div>
                        <p class="offset-top-10 text-dark text-center text-sm-left"> {{ stepDef.description }} </p>
                        <!-- <p class="offset-top-10 text-dark text-center text-sm-left"> <i class="fa fa-archve"></i>Configurado para cumplimentarse en {{ stepDef.steps.length}} pasos. </p> -->
                        <p class="offset-top-10 text-dark text-center text-sm-left">
                            <!-- <button (click)="selectStepDefinition(stepDef)" class="btn btn-primary btn-sm d-inline m-t-md m-r-md"><i class="fas fa-lg fa-forward"></i> Iniciar expediente</button> -->
                            <button (click)="showCreateDossierPopup(stepDef)"
                                class="btn btn-primary btn-sm d-inline m-t-md m-r-md">
                                <i class="fas fa-lg fa-forward"></i> {{ 'ProcurementProject.models.init' | translate }}
                            </button>
                            <!--button (click)="selectStepDefinition(stepDef, true)" class="btn btn-outline-dark btn-sm d-inline m-t-md">
                <i class="far fa-clone"></i> {{ 'ProcurementProject.models.create' | translate }} </button-->
                        </p>
                        <p class="offset-top-10 text-dark text-center text-sm-left"></p>
                    </div>
                    <div class="col-md-9 col-lg-4 offset-xl-0 offset-top-50 offset-lg-top-0">
                        <div
                            class="unit align-items-center unit-spacing-xs unit-xs flex-sm-row text-center text-sm-left">
                            <div class="unit-left">
                                <span class="icon novi-icon text-middle icon-sm text-primary mdi mdi-chart-bar"></span>
                            </div>
                            <div class="unit-body">
                                <h5 class="text-uppercase font-weight-bold"></h5>
                            </div>
                        </div>
                        <p class="offset-top-10 text-dark text-center text-sm-left">.</p>
                    </div>
                    <!--div class="col-md-9 col-lg-4 offset-xl-0 offset-top-50 offset-lg-top-0">

            <div class="unit align-items-center unit-spacing-xs unit-xs flex-sm-row text-center text-sm-left">
              <div class="unit-left"><span class="icon novi-icon text-middle icon-sm text-primary mdi mdi-newspaper"></span></div>
              <div class="unit-body">
                <h5 class="text-uppercase font-weight-bold">Employment blog</h5>
              </div>
            </div>
            <p class="offset-top-10 text-dark text-center text-sm-left">We have recently launched our employment blog where we review top rated vacancies and give useful advice to our readers.</p>
          </div-->
                </div>
            </div>
        </div>
        <!-- ZONA DE FORMULARIO -->
        <ng-container *ngIf="model">
            <div class="alert alert-info" role="alert">
                <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-5" aria-hidden="true"></i>{{
                    'ProcurementProject.models.info' | translate }}</span>
            </div>
        </ng-container>
        <div #formContainer></div>
    </div>
</div>
<p-dialog header="Seleccionar modelo" [(visible)]="dossierPopupVisible" [responsive]="false" showEffect="fade"
    [modal]="true" (onHide)="onCloseDossierModel()" [resizable]="false" [closable]="true" [dismissableMask]="true"
    [closeOnEscape]="false" [blockScroll]="true" [style]="{'width':'60vw'}"
    [contentStyle]="{ 'max-height': '80vh', overflow: 'hidden'}">
    <sub-header [isModal]="true" [includeContextHelp]="true" *ngIf="dossierPopupVisible">
    </sub-header>
    <p-scrollPanel [style]="{width: '100%', height: '50vh'}" styleClass="custombar1" *ngIf="dossierPopupVisible">
        <div class="wrapper wrapper-content">
            <div class="container-fluid">
                <div class="row">
                    <div class=" alert alert-info col-12" role="alert">
                        <i class="fas fa-lg fa-info-circle m-r-lg"></i> {{ 'ProcurementProject.models.selectInfo' |
                        translate }}
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 ui-datalist-content ui-widget-content">
                        <button (click)="createNew(stepDefinition)"
                            class="btn btn-primary btn-sm d-inline m-t-md m-r-md"> <i class="fas fa-plus"></i> {{
                            'ProcurementProject.models.new' | translate }} </button>
                    </div>
                    <div class="col-12  m-t-lg" *ngIf="models && models.length > 0">
                        <p-table [value]="models" sortField="name" sortOrder="1" [rows]="20" [paginator]="false"
                            [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 100]"
                            class="footer-over-pagination  mb-3 table table-striped table-hover ">
                            <ng-template pTemplate="header">
                                <tr class="ui-widget-header m-t-md">
                                    <th class="p-md">
                                        <strong> {{ 'ProcurementProject.models.selectTHeader' | translate }}</strong>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-model>
                                <tr>
                                    <td>
                                        <span style="line-height: 2em;"><i class="fa fa-clone fa-lg m-r-lg"></i>{{
                                            model.contractFolderId }} {{ model.abbreviatedTitle }}</span> <button
                                            class="btn btn-sm btn-primary t-action-button float-right"
                                            aria-expanded="false" (click)="createDossierFromModel(model)">
                                            <i class="fas fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </div>
        </div>
    </p-scrollPanel>
</p-dialog>